import React from "react";
import BreadCrumbsComponent from "../common/BreadCrumbs";

export default function RefundPolicyCrumbs() {
  return (
    <BreadCrumbsComponent
      firstLevel={"Home"}
      secondLevel={"Legal"}
      mainHeading={"Refund and Cancellation Policy"}
    />
  );
}
